'use client';

import React from 'react';
import { IContactUs } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import Img from '../../components/Img';
import AnimatedTitle from '../../components/AnimatedTitle';
import styles from './Contacts.module.scss';
import ContactModal from '../../components/ContactModal';
import FAQSection from './FAQSection';

const Contacts = ({ data }: { data: IContactUs }) => (
  <main
    className={styles.contacts}
  >
    <div id='contact-form'>
      <ContactModal
        isBlockView
        titleComponent='h1'
      />
    </div>
    <section
      className={classnames(styles.contactsSection)}
    >
      <div className={classnames(styles.contactSectionContent, 'container')}>
        <h2 className={classnames(styles.title, 'title3')}><AnimatedTitle title='Our global **presence**' /></h2>
        <div className={styles.addresses}>
          {data.addresses.map(address => (
            <div
              className={styles.address}
              key={address.id}
            >
              {address.image?.url && (
                <Img
                  className={styles.map}
                  src={address.image ? address.image.url : '/'}
                  alt={address.image?.alternativeText || 'address image'}
                  width={244}
                  height={244}
                  withPreloader // eslint-disable-next-line
                  preloader='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB2lBMVEVHcExtybhwz79rnZZro5tqnJVrpZxqlo9txLdrvrFuyr5qp51sraNtxbhroZpqyLpuvbFtyLltzLpsv7Nrv7JtsaVsuq5rtqts0LxtsqZswrVssKZrqZ9sw7Zv0MNrqqBswrZtxrZql5BvzL1uxbZ00sR00L5sxLduua5yyMJpyr1sw7Zstaprwrdxzb9stahu0r9turBrwLZvy75rpJxqw7hrpJtuwbJtw7drwLNrv7NruK1rraNrwbdtvrJrjIhsvbJrpJtswLJtxrpvxrlsxLNrraNriYVtt6xtwbRrqJ1tua5uua1sxLRsw7VrtKlrpp1txLpphoBswbVtuq9uyMFrp5xsxrdtuq5rqJ9svbFtua5ssahro5xvyb1syL1uxbhtyrhqlo9rqqBstKlssaVrqaBqnpdrrKJqf3tqhYBrqJ9rnZVqnZVrrqRqn5drraNrpp1qgn5ql5BrpJxrrKJrlpBsr6RroJdrsadqkotpm5NqeHVrpJtqeXdpo5lroZpqgX5qd3Vqj4prnZVpi4Zrw7VpWVtqioVr1sVqe3hrlY1qg4BrwbNpfntpZWVqm5VrnpZqmpNqjIdrnZVqh4NpcnFrn5drmZNqh4Jrzb5qkIpqiYRphYFHw10aAAAAnnRSTlMAAQEEAQQGBAECAQMCAQECAQEBAgECAwEBAgICAgIBAgIBAQEBAQECAQEBAQMCAgEBAgEBAwICAgEDAwQCAQIEAgEBAgEBAQECAgEDAgECBAYBAQIDAQQCAQEDAQIEAQECAQkFAQMFBAEKAwQHBwIDBgcGCAYEBwUBAggDCAMEAQIDDAYDAx4EAhkIBg0gCQkBBgQGBQgLAQMBGwYHBRvOIJ4AAADzSURBVBgZXcGDdsMAAEDR161t2tm2bdu23dm2bdv71zVNsnPWe5FFotOF+/JfEiTiog+IRhYFxMTjbUOEmx5Jgj24egLWatyRJXuBvw9gZ4nCLzaTwrYqjIQgZFbNkJKGUXk+f/JQ9yI6WGxC0dLBHKLdiUkU1d1sCXBxereNoqSLvZkluPk8u0TRnwVjj/wcvt5efyAzVMLO8/vJ98v506ZmH5PWxlxGl++Fq6OvwVVNQxmi0L7UmrVxjh/emF4np94BUVxxOsMbQ9qFKS1Q4IxJGBkVPSOzK/OdgK0jEotgRNlFtQMhmKlrL1UFYsbJA8kvnukwot2dR94AAAAASUVORK5CYII='
                />
              )}
              <p className={styles.address__city}>
                {address.flag?.url && (
                  <Img
                    className={styles.flag}
                    src={address.flag.url}
                    alt={address.flag.alternativeText || 'address flag'}
                    width={18}
                    height={12}
                  />
                )}
                {address.city}
              </p>
              <div className={styles.info}>
                <p className={styles.address__text}>{address.street}</p>
                <a
                  className={styles.address__text}
                  href={`mailto:${address.email}`}
                >
                  {address.email}
                </a>
                {address.phone && (
                  <a
                    className={styles.address__text}
                    href={`tel:${address.phone}`}
                  >
                    {address.phone}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    <FAQSection faq={data.faq} />
  </main>
);

export default Contacts;
